import { render, staticRenderFns } from "./right-info-panel.vue?vue&type=template&id=0fff9924&scoped=true"
import script from "./right-info-panel.vue?vue&type=script&lang=js"
export * from "./right-info-panel.vue?vue&type=script&lang=js"
import style0 from "./right-info-panel.vue?vue&type=style&index=0&id=0fff9924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fff9924",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
